module.exports = __webpack_public_path__ + "static/media/fotorrhh1.e6c71cd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rrhh/fotorrhh1.jpg
// module id = 1012
// module chunks = 0